import { css } from "@emotion/react";

import transition from "~/utilities/transition";

const getButtonColor = (theme, active, backgroundColor) => {
    switch (backgroundColor) {
        case "yellow":
            return css`
                background-color: ${active
                    ? theme.buttonBackgroundColor.yellow.hover
                    : theme.buttonBackgroundColor.yellow.color};
                color: ${theme.palette.black};

                &:hover,
                &:focus {
                    background-color: ${theme.buttonBackgroundColor.yellow
                        .hover};
                }
            `;
        case "white":
            return css`
                background-color: ${active
                    ? theme.buttonBackgroundColor.white.hover
                    : theme.buttonBackgroundColor.white.color};
                border: 1px solid ${theme.palette.darkGray};
                color: ${theme.palette.black};

                &:hover,
                &:focus {
                    background-color: ${theme.buttonBackgroundColor.white
                        .hover};
                }
            `;
        case "black":
            return css`
                background-color: ${active
                    ? theme.buttonBackgroundColor.black.hover
                    : theme.buttonBackgroundColor.black.color};
                color: ${theme.palette.white};

                &:hover,
                &:focus {
                    background-color: ${theme.buttonBackgroundColor.black
                        .hover};
                }
            `;
        case "blue":
            return css`
                background-color: ${active
                    ? theme.buttonBackgroundColor.blue.hover
                    : theme.buttonBackgroundColor.blue.color};
                color: ${theme.palette.white};

                &:hover,
                &:focus {
                    background-color: ${theme.buttonBackgroundColor.blue.hover};
                }
            `;
        default:
            return css`
                background-color: ${active
                    ? theme.buttonBackgroundColor.yellow.hover
                    : theme.buttonBackgroundColor.yellow.color};
                color: ${theme.palette.black};

                &:hover,
                &:focus {
                    background-color: ${theme.buttonBackgroundColor.yellow
                        .hover};
                }
            `;
    }
};

const buttonStyles = ({ theme, active, backgroundColor }) => css`
    ${getButtonColor(theme, active, backgroundColor)};
    ${transition({}, "background-color")};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 2rem;
    line-height: 1;
    font-weight: 900;
    padding: 18px 25px;
    cursor: pointer;
`;

export default buttonStyles;
